// Zoeken gebruikt één regel: naam, producttype, tag en SKU, via verborgen
// velden in elk zoekformulier (snippets/aza-search-options.liquid, upgrade
// NZ-06). Vroeger werd elke zoekopdracht omgezet naar title:"..." en daarvoor
// werd de pagina een tweede keer geladen. Alleen oude links en bladwijzers met
// title:"..." worden nog één keer omgezet naar de gewone zoekterm.
if (/\/search\/?$/.test(window.location.pathname)) {
  const url = new URL(window.location.href);
  const query = url.searchParams.get('q') || '';
  const oud = query.match(/^title:"(.*)"$/);
  if (oud) {
    url.searchParams.set('q', oud[1].trim());
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[fields]', 'title,product_type,tag,variants.sku');
    url.searchParams.delete('page');
    window.location.replace(url.href);
  }
}
